<template>
    <div class="fixed inset-0 z-[1000] bg-black bg-opacity-50" @click="closeAddressModal"></div>
    <div
        class="fixed top-0 right-0 z-[1001] h-full w-full sm:w-1/2 md:w-1/2 lg:w-1/2 bg-white shadow-lg transform transition-transform duration-300 ease-in-out flex flex-col">
        <!-- Header -->
        <div class="flex items-center justify-between px-4 py-3 border-b">
            <h3 class="text-lg font-bold">
                {{title}}
            </h3>
            <button @click="closeModal" class="text-gray-500 hover:text-gray-900">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                    </path>
                </svg>
            </button>
        </div>

        <!-- Body -->
        <div class="relative py-5 px-5 overflow-y-auto pb-28 sm:pb-20"
            :class="{ 'overflow-hidden pointer-events-none': loading }">
            <!-- Loader Overlay -->
            <LoaderComponent v-if="loading" />
            <!-- The form and complete body content here -->
            <slot v-if="!loading"></slot>
        </div>

        <!-- Footer / Buttons -->
        <div
            class="flex justify-end gap-2 px-4 py-3 border-t bg-white sm:relative fixed bottom-0 left-0 w-full sm:w-auto sm:bottom-auto sm:left-auto sm:px-4 sm:py-3">
            <button @click="close" class="px-5 py-2 rounded-full border border-gray-300 bg-white hover:bg-gray-100">
                Cancel
            </button>
            <button @click="handleSubmit" class="px-5 py-2 rounded-full bg-yellow-400 hover:bg-yellow-500 text-white">
                {{ loading ? "Loading ..." : "Save" }}
            </button>
        </div>
    </div>
</template>

<script>
import LoaderComponent from "@/components/Global/Modals/LoaderComponent.vue";

export default {
    name: "DefaultModal",
    components: { LoaderComponent },
    props: {
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loading: false,
            open_model: false,
            errors: {}
        };
    },

    methods: {
        openModal() {
            document.body.classList.add('overflow-hidden')
            this.open_model = true;
        },
        closeModal() {
            this.open_model = false;
            document.body.classList.remove('overflow-hidden')
            // this.form = {};
            this.errors = {};
        },
        handleSubmit() {
            this.loading = true;
            // Simulate an async operation
            setTimeout(() => {
                this.loading = false;
                this.closeAddressModal();
            }, 2000);
        }
    },
    mounted() {
        //
    },
};
</script>